import type { Appointment } from "@/types/appointments/api-types/appointment-types";
import type { CalendarBlock } from "@/types/appointments/calendar-types";

export function toCalendarBlocks(appointments: Appointment[]): CalendarBlock[] {
  return appointments.flatMap((appointment) =>
    appointment.services.map((line) => ({
      id: line.id,
      appointment_id: appointment.id,
      staff_id: line.staff_id,
      start_time: line.start_time,
      duration_minutes: line.duration_minutes,
      client_name: appointment.client_name ?? "",
      service_name: line.service_name ?? "",
      status: appointment.status,
      category_id: line.category_id ?? null,
    }))
  );
}
